module.exports = __webpack_public_path__ + "img/48-image-1@2x.fb80aebb.png";